export const SET_AUTH_DATA = "AUTH/SET_AUTH_DATA";
export const DEL_AUTH_DATA = "AUTH/DEL_AUTH_DATA";
export const SET_LOADING = "AUTH/SET_LOADING";
export const CONFIRM = "AUTH/CONFIRMED";
export const SET_TOUR = "AUTH/SET_TOUR";
export const SET_LANG_FETCHING = "AUTH/SET_LANG_FETCHING";
export const SET_AUTH_FETCHING = "AUTH/SET_AUTH_FETCHING";
